import React from "react";
import { Fade } from "react-awesome-reveal";
import { IContactBannerData } from "../../exports/interfaces";
import { useCompanyDetailsContext } from "../../context/CompanyDetailsContext";

const Location = (props: { contact: IContactBannerData[] }) => {
  const { companyDetailsData } = useCompanyDetailsContext();
  return (
    <>
      {/* <section
        className="elementor-section elementor-top-section elementor-element elementor-element-e5f8f5c elementor-section-boxed elementor-section-height-default elementor-section-height-default custom-elementor-element-e5f8f5c"
        data-id="e5f8f5c"
        data-element_type="section"
        data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
        style={{height: '50dvh', marginTop:'unset', position:'relative'}}
      >
        <div className="custom-aboutus-gradient"></div>
        <div className="elementor-container elementor-column-gap-default custom-location-elementor-container">
          <div className="elementor-row custom-row-element" style={{ display: "flex", padding: '0px 30px', justifyContent: 'space-evenly' }}>
            <div
              className="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-ede563a"
              data-id="ede563a"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap custom-contact-elementor-widget-wrap" style={{width: '65dvw'}}>
                  <div
                    className="elementor-element elementor-element-b75fa6e elementor-widget elementor-widget-heading"
                    data-id="b75fa6e"
                    data-element_type="widget"
                    data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h1 className="elementor-heading-title elementor-size-default">
                        Located in Sinamangal, Kathmandu
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-b0e4dfe"
              data-id="b0e4dfe"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
              style={{display: 'flex', alignItems: 'center', justifyContent:'center'}}
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <div
                    className="elementor-element elementor-element-13a71e5 elementor-align-right elementor-mobile-align-center elementor-widget elementor-widget-button"
                    data-id="13a71e5"
                    data-element_type="widget"
                    data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                    data-widget_type="button.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-button-wrapper">
                        <a
                          href="https://maps.app.goo.gl/C4efUCTXSGQ5L4nR8"
                          target="_blank"
                          rel="noreferrer"
                          className="elementor-button-link elementor-button elementor-size-md elementor-animation-grow"
                          role="button"
                          style={{ padding: "15px" }}
                        >
                          <span className="elementor-button-content-wrapper">
                            <span className="elementor-button-icon elementor-align-icon-left" style={{paddingRight:'10px'}}>
                              <i
                                className="fa fa-map-marker"
                                aria-hidden="true"
                              ></i>
                            </span>
                            <span className="elementor-button-text">
                              Get Direction
                            </span>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-13e91cd2 elementor-section-stretched elementor-section-height-min-height elementor-section-full_width elementor-section-height-default elementor-section-items-middle custom-elementor-element-13e91cd2"
        data-id="13e91cd2"
        data-element_type="section"
        data-settings='{"stretch_section":"section-stretched","background_background":"classNameic","hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
        style={{
          position: "relative",
          backgroundImage: props?.contact[0]?.image[0]?.media?.name
            ? `url(${process.env.REACT_APP_cmsUrl}/uploads/${props?.contact[0]?.image[0]?.media?.name})`
            : "url(https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png)",
        }}
      >
        {/* <div className="elementor-background-overlay"></div> */}
        <div className="elementor-container elementor-column-gap-default">
          <div className="custom-aboutus-gradient"></div>
          <div className="elementor-row" style={{ width: "100%", zIndex: 1 }}>
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4628aac3"
              data-id="4628aac3"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <Fade direction="down" triggerOnce={true}>
                  <div className="elementor-widget-wrap custom-elementor-title">
                    <div
                      className="elementor-element elementor-element-121e1335 elementor-invisible elementor-widget elementor-widget-heading"
                      data-id="121e1335"
                      data-element_type="widget"
                      data-settings='{"_animation":"fadeInUp","hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h1 className="elementor-heading-title elementor-size-default">
                          {props?.contact[0]?.title}
                        </h1>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-147259cb elementor-invisible elementor-widget elementor-widget-heading"
                      data-id="147259cb"
                      data-element_type="widget"
                      data-settings='{"_animation":"fadeInUp","_animation_delay":400,"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h5 className="elementor-heading-title elementor-size-default">
                          {props?.contact[0]?.description}
                        </h5>
                      </div>
                      <div
                        className="elementor-element elementor-element-13a71e5 elementor-align-right elementor-mobile-align-center elementor-widget elementor-widget-button"
                        data-id="13a71e5"
                        data-element_type="widget"
                        data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                        data-widget_type="button.default"
                        style={{ marginTop: "10px" }}
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-button-wrapper">
                            <a
                              href={
                                companyDetailsData[0]?.attributes?.Get_Direction
                              }
                              target="_blank"
                              rel="noreferrer"
                              className="elementor-button-link elementor-button elementor-size-md elementor-animation-grow"
                              role="button"
                              style={{ padding: "15px 30px" }}
                            >
                              <span className="elementor-button-content-wrapper">
                                <span
                                  className="elementor-button-icon elementor-align-icon-left"
                                  style={{ paddingRight: "10px" }}
                                >
                                  <i
                                    className="fa fa-map-marker"
                                    aria-hidden="true"
                                  ></i>
                                </span>
                                <span className="elementor-button-text">
                                  Get Direction
                                </span>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Location;
